import Service, { getCallApiFunction } from '../service'

interface BodyType {
  roomId: string
  shares?: number
}

class IncreaseSharesApi extends Service {
  constructor(data: BodyType) {
    super()
    this.name = 'INCREASE_SHARES'

    this.config = {
      url: `/v1/room/incr-shares`,
      method: 'POST',
      data,
    }
  }
}

export const increaseShares = (data: BodyType) => getCallApiFunction(new IncreaseSharesApi(data))
